
.ContentMainHeader {
    padding: 3rem 1rem;
    margin: 0 auto;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    text-align: center;
    min-height: 20vh;
    max-width: var(--soniq-t--global--container--width--primary--sm);

    @media (min-width: 600px) {
        padding-left: 0;
        padding-right: 0;
    }
}

.ContentMainHeader__headline {
    margin-bottom: 1rem;
}
